import moment from 'moment-timezone';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { ExclamationCircleOutlined, PauseCircleOutlined } from '@ant-design/icons';
import { Button, Modal, Space, Tooltip, message } from 'antd';
import { ConfirmAction } from '../../../molecules/confirm/ConfirmAction';
import { ACCESS_CODE } from '../../../../constants/define/translation';
import { postLoginRepository } from '../../../../repository/mytm/auth/loginRepository';
import { UserContext } from '../../../../repository/context/userContext';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { AccessCodeRecordInterface, AccessCodeStatus } from '../../../../types/accessCode';
import { deactivateAccessCodeRepository } from '../../../../repository/mytm/access-code/accessCodeRepository';

interface ActionsColumnProps {
  record: AccessCodeRecordInterface;
  onRefresh: () => void;
}

export default React.memo((props: ActionsColumnProps) => {
  const { t } = useTranslation(ACCESS_CODE);
  const { record, onRefresh } = props;
  const userContext = useContext(UserContext);

  const [deactivating, setDeactivating] = useState(false);

  const canDeactivate =
    record.status === AccessCodeStatus.ACTIVE && record.userId && moment().isBefore(moment(record.expirationDate));

  const handleDeactivate = () => {
    Modal.confirm({
      title: t('popup.title'),
      okText: t('popup.okBtn'),
      cancelText: t('popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: (
        <ConfirmAction
          textConfirmAction={t('popup.deactivate')}
          isConfirmPassword
          textConfirmPassword={t('popup.confirmPassword')}
        />
      ),
      onOk() {
        setDeactivating(true);
        const inputPasswordNode = document.getElementById('inputPasswordForConfirm');
        const password = (inputPasswordNode as any).value;
        const updateFunc = () => {
          deactivateAccessCodeRepository({ code: record.code, userId: record.userId })
            .then(r => {
              onRefresh();
              setDeactivating(false);
              message.success(t('message.deactivateSuccess'));
            })
            .catch(e => {
              setDeactivating(false);
              message.error(e?.errorMessage);
            });
        };
        if (!userContext.user?.email || userContext.user?.email === '') {
          setDeactivating(false);
          message.error(MESSAGE_ERROR.M02);
        } else {
          postLoginRepository({
            email: userContext.user?.email,
            password,
          })
            .then(() => {
              updateFunc();
            })
            .catch((e: any) => {
              setDeactivating(false);
              message.error(e?.errorMessage);
            });
        }
      },
    });
  };

  return (
    <StyledContainer>
      <Space size="small">
        {canDeactivate && (
          <Tooltip title={t('tooltip.deactivate')}>
            <Button
              className="deactivate"
              disabled={deactivating}
              loading={deactivating}
              icon={<PauseCircleOutlined />}
              onClick={handleDeactivate}
            />
          </Tooltip>
        )}
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  button.ant-btn {
    background: #eee;
    border-color: #eee;
  }
`;
